
import Vue from 'vue';

export default Vue.extend({
	props: {
		customFieldDefinition: { type: Object, required: true }
	},
	computed: {
		label() {
			return this.customFieldDefinition.label[this.$i18n.locale];
		}
	}
});
